<div class="account-center-template">
  <div class="account-center-template__banner">
    <policy-banner *ngIf="!isAnnuity"></policy-banner>
    <annuity-banner *ngIf="isAnnuity"></annuity-banner>
  </div>
  <div class="account-center-template__body">
    <div class="account-center-template__summary-container">
      <policy-summary *ngIf="!isAnnuity"></policy-summary>
      <annuity-summary *ngIf="isAnnuity"></annuity-summary>
    </div>
    <div class="account-center-template__table-container">
      <policy-info-table *ngIf="!isAnnuity"></policy-info-table>
      <annuity-info-table *ngIf="isAnnuity"></annuity-info-table>
      <payment-details-table *ngIf="!isAnnuity"></payment-details-table>
      <policy-details-table *ngIf="!isAnnuity"></policy-details-table>
      <annuity-details-table *ngIf="isAnnuity"></annuity-details-table>
    </div>
    <div class="account-center-template__links-container">
      <policy-links *ngIf="!isAnnuity"></policy-links>
      <annuity-links *ngIf="isAnnuity"></annuity-links>
      <advisor-links *ngIf="showAdvisorLinks"></advisor-links>
    </div>
  </div>
</div>
<div *ngIf="showDocuSignCoin" class="autofill-coin" (click)="retrieveDocusignDocumentsLocal()">
  <img class="autofill-coin__image" src="/img/logo/retrieve-docusign-local.png" />
</div>
